<template>
  <div>
    <v-select v-model="selectedData" :options="results" label="ModelName"
    :reduce="(r) => r.id"
    @input="doSomething"
     @search="search" />   
    
  </div>
</template>
<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import UserService from '../../services/user.service';
var debounce = require('debounce');
export default {
  props: [],
  name: 'ModelSelectEnquery',
  components:{vSelect},
  data(){
    return{
      results:[],
      selectedData:''     
    }
  },
  methods:{
    search(search, loading){
      if (search !== "") {
        loading(true);
        this.searchVal(search,loading,'url',this)
      }
    },
    searchVal: debounce((search, loading, url, vm) => {
      let param =[];
       param.search = search
        UserService.getMetod("bajajAPI/Enquery/search_model",param).then(
            (response) => {
              // alert(response.data.models);
              vm.results = response.data.models
            },
            (error) => {
              vm.loading = false;

              vm.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );

      // var el = vm;
      // AJAX request
      
      // axios
      //   .get(url, {
      //     params: {
      //       search: search,
      //     },
      //   })
      //   .then(function (response) {
      //     vm.city_options = response.data.cities;
      //   });
      loading(false);
    }, 350),
    doSomething(){
      
      const result = this.results.find(val => val.id === this.selectedData);
      // this.selectedOptionArray = result
      this.$emit('selectedOptionArray', result)
    }
  }

};
</script>